import { useCallback, useEffect } from 'react';

import { useVisibleState } from '@/shared/hooks/useVisibleState';
import { useUser } from '@/shared/providers/user-provider/use-user';

import { buildAuthModalCloseUrl } from './check-and-open-url-rules';

export const useAuthManagementController = () => {
  const { open, visible, close } = useVisibleState(false);
  const { user } = useUser();
  const userAction = user?.action;

  const onClose = useCallback(() => {
    if (typeof window !== 'undefined') {
      const currentUrl = window.location.pathname + window.location.search;
      const finalUrl = buildAuthModalCloseUrl({
        pathname: window.location.pathname,
        search: window.location.search,
      });

      if (finalUrl !== currentUrl) {
        window.history.replaceState(null, '', finalUrl);
      }
    }

    close();
  }, [close]);

  useEffect(() => {
    if (userAction === 'edit-phone' || userAction === 'change-password-sms') {
      open();
    }
  }, [open, userAction]);

  return { open, visible, onClose };
};
